import DemoMode from "../../Views/Errors/DemoMode";
import Error from "../../Views/Errors/Error";
import PageNotFound from "../../Views/Errors/PageNotFound";
import ServerError from "../../Views/Errors/ServerError";
import Unauthorized from "../../Views/Errors/Unauthorized";

export default [
    /*
    |
    | The route below is our catch-all route. The idea is that if none of the previously configured routes matches the
    | current request, the route below is used instead. This route is listed before any of the other error routes, so
    | a user never accidentally ends up there.
    |
    */
    {
        path:'*',
        component:PageNotFound,
        name:'page.not.found',
    },


    /*
    |
    | The routes below are *never* reached by any requested route. These routes work in conjunction with the
    | interceptors configured in Axios. Check the bootstrap.js file for usage.
    |
    */
    {
        path:'*',
        component:DemoMode,
        name:'demomode',
    },
    {
        path:'*',
        component:Error,
        name:'error',
    },
    {
        path:'*',
        component:ServerError,
        name:'servererror',
    },
    {
        path:'*',
        component:Unauthorized,
        name:'unauthorized',
    },
];
